import request from '@/utils/request';

export interface MapRouteItemType {
  completeTestTime: string | null;
  deliveryStatus: string;
  lineReportId: number;
  lineReportStatus: string;
  mapReleaseTime: string | null;
  mapRouteId: number;
  mapRouteStatus: string;
  modifying: boolean;
  name: string;
  organizationId: number;
  organizationName: string;
  overTime: boolean;
  startTestTime: string | null;
  stationId: number;
  stationName: string;
  testManagerUserId: number | null;
  testManagerUserName: string | null;
}

export const getMapRouteList = (params: any) =>
  request.post<any, CommonListRes<MapRouteItemType>>(
    `/app-server/mapRoute/list`,
    params,
  );

export interface StatusCountItemType {
  collectingCount: number;
  completedCount: number;
  pendingTestCount: number;
  testingCount: number;
}

export const getStatusCount = (name: string) =>
  request.post<any, CommonRes<StatusCountItemType>>(
    `/app-server/mapRoute/statusCount`,
    { name },
  );

export interface MapRouteDetailItemType {
  id: number;
  lineName: string;
  organizationName: string;
  provinceName: string;
  cityName: string;
  districtName: string;
  stationName: string;
  allMotorWay: boolean;
  serialType: string;
  specialRequirement: string;
  specialRemark: string;
  exceptionLineRemark: string;
  stops: {
    id: number;
    stopName: string;
    stopAddress: string;
  }[];
  status: string;
  statusName: string;
  mapRouteId: number;
  modifying?: boolean;
  testManagerUserId?: number;
  testManagerUserName?: string;
  isTestManagerUser?: boolean;
  completeTestTime?: string;
  acceptInfoList?: any[];
  organizationId: number;
  viewStatusName: string;
  viewStatusNameList: string[];
}

export const getMapRouteDetail = (id: string | number) =>
  request.post<any, CommonRes<MapRouteDetailItemType>>(
    `/app-server/mapRoute/getDetail/${id}`,
  );

export interface CurrentUserInfoType {
  id: number;
  username: string;
  roleList: any;
  organization: {
    id: number;
    name: string;
    code: string;
    contact: string;
    telephone: string;
    deliverUserId: number;
    deliverUserName: string;
  };
  enable: boolean;
  token: string;
  mobileNumber: string;
  email: string;
  userType: string;
  userTypeName: string;
  simplePw: boolean;
  expirationTime: string;
  feishuId: string;
  manageAll: boolean;
}

export const getCurrentUserInfo = () => {
  //@ts-ignore
  return request<any, CommonRes<CurrentUserInfoType>>({
    url: '/admin-server/user/current',
    method: 'get',
    messageFree: true,
  });
};

export const changeMapRouteStatus = (
  ids: number[],
  status: string,
  remark?: string,
) =>
  request.put<any, CommonRes<null>>(
    `/app-server/mapRoute/changeMapRouteStatus`,
    {
      mapRouteIds: ids,
      statusCode: status,
      remark,
    },
  );

// 上传路线验收单
export const uploadRouteAcceptInfo = (data: any): Promise<any> => {
  return request({
    url: '/app-server/routeVehicleAcceptInfo/saveRouteVehicleAcceptInfo',
    method: 'POST',
    data,
  });
};
